import { render } from "./Radio.vue?vue&type=template&id=115ce8c5&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"

import "./Radio.vue?vue&type=style&index=0&id=115ce8c5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115ce8c5"]])

export default __exports__